mutation AssignCorporateAccounts($input: AssignCorporateAccountsInput!) {
  assignCorporateAccounts(input: $input) {
    assignedCorporateAccounts
  }
}
